import React, { useState, useEffect } from 'react'
import img from '../home/home-img/Screenshot_17-12-2024_224833_-removebg-preview (1).png'
import '../home/Home.css'

import { Link as RouterLink } from "react-router-dom";
import { HashLink } from "react-router-hash-link";
import { isLoggedIn, logout } from "../../utils/auth";
import LoginPopup from '../Login/loginPopup';

const Nav = () => {

  const [isOpen, setIsOpen] = useState(false);
  const [showLogin, setShowLogin] = useState(false);
  const [walletBalance, setWalletBalance] = useState(null);

  // ✅ cart count from API
  const [cartCount, setCartCount] = useState(0);

  const toggleMenu = () => {
    setIsOpen(!isOpen)
  };

  const handleAuth = () => {
    if (isLoggedIn()) {
      logout();
      window.location.reload();
    } else {
      setShowLogin(true);
    }
  };

  // 🔥 FETCH CART → GET API (NO COUNT API)
  const fetchCartCount = async () => {
    try {
      const token = localStorage.getItem("idToken");
      if (!token) return;

      const res = await fetch(
        "https://host.aizoplug.com:3000/ecommerce/cart",
        {
          headers: {
            "Authorization": `Bearer ${token}`
          }
        }
      );

      const data = await res.json();

      if (data.success) {
        // ✅ OPTION 1: number of products
        // setCartCount(data.data.length);

        // ✅ OPTION 2 (RECOMMENDED 🔥): total quantity
        const totalQty = data.data.reduce(
          (sum, item) => sum + (item.quantity || 0),
          0
        );

        setCartCount(totalQty);
      }

    } catch (err) {
      console.error("Cart fetch error:", err);
    }
  };

  // 🔥 FETCH WALLET
  const fetchWallet = async () => {
    try {
      const token = localStorage.getItem("idToken");
      if (!token) return;

      const res = await fetch(
        "https://host.aizoplug.com:3000/app/api/display/wallet/",
        {
          headers: {
            "Authorization": `Bearer ${token}`
          }
        }
      );

      const data = await res.json();

      if (data.wallets && data.wallets.length > 0) {
        setWalletBalance(data.wallets[0].balance);
      }

    } catch (err) {
      console.error("Wallet fetch error:", err);
    }
  };

  // ✅ INITIAL LOAD
  useEffect(() => {
    if (isLoggedIn()) {
      fetchWallet();
      fetchCartCount();
    }
  }, []);

  // 🔥 AUTO REFRESH WHEN CART UPDATED
  useEffect(() => {
    const handleCartUpdate = () => {
      fetchCartCount();
    };

    window.addEventListener("cartUpdated", handleCartUpdate);

    return () => {
      window.removeEventListener("cartUpdated", handleCartUpdate);
    };
  }, []);

  return (
    <>
      <div className="nav-main">

        <div className="logo">
          <img src={img} alt="" />
        </div>

        <div className={`pages ${isOpen ? 'open' : ''}`}>
          <i className="fa-solid fa-x" id='cancel' onClick={toggleMenu}></i>

          <p><HashLink smooth to="/#homee">Home</HashLink></p>
          <p><HashLink smooth to="/#about">About Us</HashLink></p>
          <p><HashLink smooth to="/#service">Service</HashLink></p>
          <p><RouterLink to="/product">Product</RouterLink></p>
          <p><RouterLink to="/orders">Orders</RouterLink></p>
          {/* MOBILE MENU BUTTON */}
          <button className='nav_login_btn mobile-only' onClick={handleAuth}>
            {isLoggedIn() ? "Logout" : "Login"}
          </button>
        </div>

        <div className="qout">

          {isLoggedIn() && walletBalance !== null && (
            <div className="wallet-balance">
              ₹ {walletBalance}
            </div>
          )}

          <RouterLink to="/cart" className="cart-icon">
            <i className="fa-solid fa-cart-shopping"></i>

            {cartCount > 0 && (
              <span className="cart-count">{cartCount}</span>
            )}
          </RouterLink>

          {/* DESKTOP BUTTON */}
          <button className='nav_login_btn desktop-only' onClick={handleAuth}>
            {isLoggedIn() ? "Logout" : "Login"}
          </button>

          <div className="label" onClick={toggleMenu}>
            {isOpen ? (
              <i className="fa-solid fa-x" id='cancel'></i>
            ) : (
              <i className="fa-solid fa-bars" id='btn'></i>
            )}
          </div>
        </div>
      </div>

      <LoginPopup
        show={showLogin}
        onClose={() => setShowLogin(false)}
      />
    </>
  );
}

export default Nav;